import React from 'react';

const Input = ({
  type,
  name,
  className,
  value,
  onChange,
  placeholder,
  required,
  disabled,
}) => {
  return type === 'textarea' ? (
    <textarea
      name={name}
      className={`block w-full h-auto
          px-3 py-1.5 
          text-base font-normal 
          leading-6 
          placeholder-gray-500
          text-gray-600 
          bg-white 
          border border-gray-300 rounded-md 
          transition-colors duration-150 ease-in-out 
          disabled:bg-lightColor disabled:text-gray-300
         ${className}`}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      disabled={disabled}
      required={required}
      rows={10}
    />
  ) : (
    <input
      type={type || 'text'}
      name={name}
      className={`block w-full h-10
          px-3 py-1.5 
          text-base font-normal 
          leading-6 
          placeholder-gray-500
          text-gray-600 
          bg-white 
          border border-gray-300 rounded-md 
          transition-colors duration-150 ease-in-out 
          disabled:bg-lightColor disabled:text-gray-300
         ${className}`}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      disabled={disabled}
      required={required}
    />
  );
};

export default Input;
